import { deleteRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function deleteOrderTemplateRequest(id) {
	let url = orderTemplates.getByIdPath(id);
	await deleteRequest(url);
}